import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import { gsap } from "gsap/all"

import Swiper from "swiper"
import { TYPE } from "../../../theme/styles/globals"

export default class Carousel extends React.Component {
  state = {
    currentSlide: 0,
  }

  componentDidMount() {

    const { id } = this.props
    const _this = this

    this.swiper = new Swiper(`#swiper-${id}`, {
      slidesPerView: this.props.slidesPerView,
      centeredSlides: this.props.centeredSlides,
      spaceBetween: this.props.spaceBetween,
      autoplay: this.props.autoplay,
      loop: true,
      on: {
        slideChange: function (e) {
          _this.slideChange(e.activeIndex)
        },
      },
    })

  }

  slideChange(slide) {
    const { id, children } = this.props

    // this.setState({ currentSlide: slide }, () => {
    //     children.forEach((child, i) => gsap.to(`.swiper-slide-${id}-${i}`, { duration: 1, opacity: (i === this.state.currentSlide) ? 1 : 0.3, ease: "sine.easeOut" }))
    // })
  }

  render() {

    const { id, children, mode, message } = this.props

    return (
      <Wrapper>
        <div className="swiper-container" id={`swiper-${id}`}>
          <div className="swiper-wrapper">
            {children.map((child, i) => (
              <div className={`swiper-slide swiper-slide-${id}-${i}`} key={i}>
                {child}
              </div>
            ))}
          </div>
        </div>
        {message && 
        <Message>
          <Label style={{ color: mode === "LIGHT" ? "#181616" : "#FFFFFF" }}>
            {message}
          </Label>
          <Arrow width={52} height={14} viewBox="0 0 52 14">
            <path
              d="M37.548 0l-.944 1.846 8.443 4.122H0V8.03h45.047l-8.443 4.124.944 1.846L52 6.999z"
              fill={mode === "LIGHT" ? "#181616" : "#FFFFFF"}
              fillRule="evenodd"
            />
          </Arrow>
        </Message>
        }
      </Wrapper>
    )
  }
  
}

Carousel.propTypes = {
  children: PropTypes.node.isRequired,
  mode: PropTypes.string,
  message: PropTypes.any,
  slidesPerView: PropTypes.number,
  centeredSlides: PropTypes.bool,
  spaceBetween: PropTypes.number,
  autoplay: PropTypes.any,
}

Carousel.defaultProps = {
  slidesPerView: 1.3,
  centeredSlides: true,
  spaceBetween: 0,
  message: "swipe to discover",
  autoplay: false
}

const Wrapper = styled.div`
  display: block;
  width: 100%;

  ${up("md")} {
    display: none;
  }
`

const Message = styled.div`
  padding-top: 40px;
  padding-bottom: 60px;
  text-align: center;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  align-content: center;
`

const Label = styled.p`
  font-family: ${TYPE.MONO_FONT};
  text-transform: uppercase;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: 2px;
  display: inline-block;
  padding-top: 1px;
`

const Arrow = styled.svg`
  display: inline-block;
  margin-left: 20px;
`
